export default __webpack_public_path__ + "static/media/bh4.6ce44ee9.jpg";